import {
  capabilities,
  homeFeatures,
  proofPoints
} from "../content/site";
import {
  CapabilityStrip,
  CTA,
  FeatureLedger,
  Hero,
  Intro,
  SplitProof
} from "../components/Section";
import { workImageSets } from "../content/workImages";

export function HomePage() {
  return (
    <>
      <Hero
        compact
        images={workImageSets.homeHero}
        title="Precision fabrication. Field-ready results."
        copy="Metalworks & Design Group delivers detailing, fabrication, finishing, and installation services for commercial and industrial metal projects throughout Florida."
        primary={{ label: "Start a Project", href: "/contact" }}
        secondary={{ label: "View our Services", href: "/services" }}
      />
      <CapabilityStrip items={capabilities} />
      <Intro
        eyebrow="What We Handle"
        title="One fabrication partner from raw stock to finished assembly."
        copy="We combine material expertise, cutting technologies, forming equipment, and finishing workflows to move projects from concept to install-ready output."
      />
      <FeatureLedger items={homeFeatures} />
      <SplitProof
        eyebrow="Why Teams Call Us"
        title="A shop structured for precise, practical delivery."
        copy="From one-off architectural pieces to repeatable production runs, the process is built to match material behavior, schedule pressure, and downstream installation needs."
        items={proofPoints}
      />
      <CTA
        title="Bring us the fabrication problem, the finished part, or everything between."
        copy="Explore services, review product categories, or send a direct project inquiry to start the conversation."
        label="Contact the Shop"
        href="/contact"
      />
    </>
  );
}
